/* eslint-disable eslint-comments/disable-enable-pair */
import React from 'react';

import { ReactComponent as OpenSeaIcon } from '../../../common/svg/button-icons/opensea-logo.svg';
import type { MogulNFTToken } from '../../../hooks/nft-contract.hooks';
import styles from './NFTViewCard.module.css';

export interface Props {
  nft: MogulNFTToken;
  contractAddress: string;
  nftBalance: number;
}

export const NFTViewCard: React.FC<Props> = props => {
  return (
    <div className={styles.card}>
      <video
        className={styles.image}
        autoPlay
        loop
        muted
        src={props.nft.metadata.videoUrl}
      />
      <div className={styles.infoContainer}>
        <div className={styles.headerContainer}>
          <div className={styles.author}>{props.nft.metadata.author}</div>
          <div className={styles.buttonContainer}>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://opensea.io/assets/${props.contractAddress}/${props.nft.id}`}
              className={styles.openSeaButton}
            >
              <OpenSeaIcon />
            </a>
          </div>
        </div>
        <div className={styles.title}>{props.nft.metadata.title}</div>
        <div className={styles.description}>
          {props.nft.metadata.description}
        </div>
        <div className={styles.otherInfoContainer}>
          <div className={styles.otherInfoHeaderColumn}>
            {props.nftBalance && props.nftBalance > 1 ? (
              <div className={styles.otherInfoHeader}>Balance</div>
            ) : undefined}
            <div className={styles.otherInfoHeader}>ISSUE DATE</div>
            {props.nft.metadata.issueNumber && (
              <div className={styles.otherInfoHeader}>Issue Number</div>
            )}
            <div className={styles.otherInfoHeader}>Total Supply</div>
            {props.nft.metadata.collection && (
              <div className={styles.otherInfoHeader}>COLLECTION</div>
            )}
          </div>
          <div className={styles.otherInfoColumn}>
            {props.nftBalance && props.nftBalance > 1 ? (
              <div className={styles.otherInfo}>{props.nftBalance}</div>
            ) : undefined}
            <div className={styles.otherInfo}>
              {props.nft.metadata.issueDate ?? 'unknown'}
            </div>
            {props.nft.metadata.issueNumber && (
              <div className={styles.otherInfo}>
                {props.nft.metadata.issueNumber}
              </div>
            )}
            <div className={styles.otherInfo}>
              {props.nft.metadata.totalSupply ?? 1}
            </div>
            {props.nft.metadata.collection && (
              <div className={styles.otherInfo}>
                {props.nft.metadata.collection}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
